import script from "./recuperanda.vue?vue&type=script&setup=true&lang=js"
export * from "./recuperanda.vue?vue&type=script&setup=true&lang=js"

import "./recuperanda.vue?vue&type=style&index=0&id=24747c90&lang=css"

const __exports__ = script;

export default __exports__